import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { theme } from './configuration/theme';
import { LanguageProvider } from './shared/contexts/LanguageContext';
import { CookieConsentProvider } from './adapters/primary/CookieConsentContext';
import { Layout } from './adapters/primary/Layout';
import { HomePage } from './adapters/primary/HomePage';
import { MEInfoPage } from './adapters/primary/MEInfoPage';
import { TimelinePage } from './adapters/primary/TimelinePage';
import { AboutUsPage } from './adapters/primary/AboutUsPage';
import { MitmachenPage } from './adapters/primary/MitmachenPage';
import { DonationPage } from './adapters/primary/DonationPage';
import { ImpressumPage } from './adapters/primary/ImpressumPage';
import { PrivacyPage } from './adapters/primary/PrivacyPage';
import { CookiePage } from './adapters/primary/CookiePage';
import { CookieSettingsPage } from './adapters/primary/CookieSettingsPage';
import { CookieBanner } from './adapters/primary/CookieBanner';
import { ScrollToTop } from './adapters/primary/ScrollToTop';
import { FloatingDonateButton } from './adapters/primary/FloatingDonateButton';
import { useAnalytics } from './shared/hooks/useAnalytics';

const AppContent: React.FC = () => {
  return (
    <Router>
      <ScrollToTop />
      <AnalyticsWrapper />
      <Layout>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/me-info" element={<MEInfoPage />} />
          <Route path="/timeline" element={<TimelinePage />} />
          <Route path="/about" element={<AboutUsPage />} />
          <Route path="/mitmachen" element={<MitmachenPage />} />
          <Route path="/instagram" element={<Navigate to="/mitmachen" replace />} />
          <Route path="/donate" element={<DonationPage />} />
          <Route path="/impressum" element={<ImpressumPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/cookies" element={<CookiePage />} />
          <Route path="/cookie-settings" element={<CookieSettingsPage />} />
        </Routes>
      </Layout>
      <FloatingDonateButton />
      <CookieBanner />
    </Router>
  );
};

// Separate component to use analytics inside Router context
const AnalyticsWrapper: React.FC = () => {
  useAnalytics();
  return null;
};

function App() {
  return (
    <LanguageProvider>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <CookieConsentProvider>
          <AppContent />
        </CookieConsentProvider>
      </ThemeProvider>
    </LanguageProvider>
  );
}

export default App;
